
import hasPageMeta from '@/mixins/hasPageMeta'
import { mapState } from 'vuex'
export default {
    mixins: [hasPageMeta],

    async fetch() {
        await this.$store.dispatch('jsonloader/fetchJson', `tools-landing.json`)
    },

    computed: {
        ...mapState({
            jsonData: (state) => state.jsonloader.data || {},
        }),

        content() {
            return this.jsonData['tools-landing.json'] || {}
        },

        heroContent() {
            return this.content?.hero || {}
        },

        metaContent() {
            return this.content?.meta || {}
        },

        siteTitle() {
            return `${
                this.selectedTaxonomy && this.selectedTaxonomy.metas && this.selectedTaxonomy.metas.meta_title
                    ? this.selectedTaxonomy.metas.meta_title
                    : this.metaContent?.title || undefined
            }`
        },

        heroTitle() {
            return this.selectedTaxonomy && this.selectedTaxonomy.name ? this.selectedTaxonomy.name : this.heroContent?.name || undefined
        },

        siteDescription() {
            return this.selectedTaxonomy && this.selectedTaxonomy.metas && this.selectedTaxonomy.metas.meta_description
                ? this.selectedTaxonomy.metas.meta_description
                : this.metaContent?.excerpt || undefined
        },

        heroExcerpt() {
            return this.selectedTaxonomy && this.selectedTaxonomy.excerpt ? this.selectedTaxonomy.excerpt : this.heroContent?.excerpt || undefined
        },

        previewImage() {
            return this.selectedTaxonomy && this.selectedTaxonomy.cover && this.selectedTaxonomy.cover.url
                ? this.selectedTaxonomy.cover.url
                : this.metaContent?.image || undefined
        },
    },
}
